import { render, staticRenderFns } from "./DialNumberEl.vue?vue&type=template&id=08081fa6&scoped=true&"
import script from "./DialNumberEl.vue?vue&type=script&lang=ts&"
export * from "./DialNumberEl.vue?vue&type=script&lang=ts&"
import style0 from "./DialNumberEl.vue?vue&type=style&index=0&id=08081fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08081fa6",
  null
  
)

export default component.exports